import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    FETCH_APPOINTMENT_DETAILS_SUCCESS
    FETCH_APPOINTMENT_DETAILS_FAILURE
`,
    {
        prefix: "confirmationdetails/"
    }
);
